import { useEffect, useState } from "react";
import DateRangePicker from "../CommonComponents/InputControls/DateRangePicker";
import DurationPicker from "../CommonComponents/InputControls/DurationPicker";
import ActiveRoles from "./ActiveRoles";
import styles from "./Dashboard.module.css";
import RevenueData from "./RevenueData";
import RevenueOverview from "./RevenueOverview";
import UserCounts from "./UserCounts";
import UserData from "./UserData";
import useNotification from "../../hooks/useNotification";
import DashboardServices from "../../services/DashboardServices";

const Dashboard = () => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const [revenueData, setRevenueData] = useState({});


  useEffect(() => {
    const fetchUserOverviewData = async () => {
      const res = await DashboardServices.getUsersOverview();

      if (res) {
        if (res.statusCode === 1) {
          setUserData(res.data);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    };
    fetchUserOverviewData();
    fetchRevenueOverviewData()
  }, []);

  const fetchRevenueOverviewData = async () => {
    const res = await DashboardServices.getRevenueOverview();

    if (res) {
      if (res.statusCode === 1) {
        setRevenueData(res.data);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } else {
      handleError(`Error: ${res.statusDesc}`);
    }
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <div className={styles.dashboard_wrap}>
      <div className={styles.title}>Dashboard</div>
      <div>
        <div className={styles.date_selection}>
          <DurationPicker />
          <DateRangePicker />
        </div>
        <UserCounts data={userData} />
        <UserData data={userData} />
        <RevenueOverview data={revenueData} />
        <RevenueData data={revenueData} />
        <ActiveRoles />
      </div>
    </div>
  );
};

export default Dashboard;
